import React from 'react';

import colors from 'shared/~bravely/variables/_colors.module.scss';
import typography from 'shared/~bravely/variables/_typography.module.scss'; // SASS Variables in JS!

// ============================================================================
// React Select
// ----------------------------------------------------------------------------
// Theme
// ============================================================================
export const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 3,
  colors: {
    danger: colors.greyBlue,
    dangerLight: colors.blueDarkest,
    neutral0: colors.whitePure,
    neutral10: colors.greyBlue,
    neutral20: colors.greyBlue,
    neutral30: colors.greyBlue,
    neutral40: colors.greyBlue,
    neutral5: colors.whiteBlue,
    neutral50: colors.blueDarkest,
    neutral60: colors.blueDarkest,
    neutral70: colors.blueDarkest,
    neutral80: colors.blueDarkest,
    neutral90: colors.blueDarkest,
    primary: colors.greyBlue,
    primary25: colors.greyBlue,
    primary50: colors.greyBlue,
    primary75: colors.greyBlue,
  },
});

const applyStyles = (styles) => (provided, state) => ({
  ...provided,
  ...styles,
});

const fontSize = {
  fontSize: typography.fontSizeButton,
};

const multiValueLabel = {
  fontSize: typography.fontSizeButton,
  background: colors.brightYellow,
  color: colors.blueDarkest,
};

const multiValueRemove = {
  ...multiValueLabel,
  cursor: 'pointer',
};

// ============================================================================
// React Select
// ----------------------------------------------------------------------------
// Fine Tune Styles
// ============================================================================
export const selectStyles = {
  // https://react-select.com/styles
  // clearIndicator: {},
  container: applyStyles(fontSize),
  // control: (provided, state) => ({
  //   ...provided,
  //   border: 'none',
  // }),
  // dropdownIndicator: {},
  // group: {},
  groupHeading: applyStyles(fontSize),
  // indicatorsContainer: {},
  // indicatorSeparator: {},
  // input: {},
  // loadingIndicator: {},
  // loadingMessage: {},
  // menu: {},
  // menuList: {},
  // menuPortal: {},
  // multiValue: {},
  multiValueLabel: applyStyles(multiValueLabel),
  multiValueRemove: applyStyles(multiValueRemove),
  // noOptionsMessage: {},
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? colors.brightYellow : null,
    color: state.isSelected ? colors.blueDarkest : null,
  }),
  // placeholder: {},
  // singleValue: (provided, state) => {
  //   const opacity = state.isDisabled ? 0.5 : 1;
  //   const transition = 'opacity 300ms';
  //   return { ...provided, opacity, transition };
  // },
  // valueContainer: {},
};
